export default "__VITE_ASSET__83sbSwAJ__"